import React from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
} from "reactstrap"
import { useSelector } from "react-redux"

const NotAuthorized = () => {
  const allowedModules = useSelector(state => state.Login.message || [])

  return (
    <div
      className="page-content bg-light"
      style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={6}>
            <Card className="shadow-lg border-0">
              <CardHeader className="bg-danger text-white text-center">
                <h4 className="mb-0">Access Denied</h4>
              </CardHeader>
              <CardBody className="text-center p-5">
                <div className="mb-4">
                  <i
                    className="bx bx-block bx-lg text-danger"
                    style={{ fontSize: "5rem" }}
                  ></i>
                </div>
                <h2 className="text-dark mb-3">403 - Not Authorized</h2>
                {/* <p className="text-muted">
                  You do not have permission to access this page.
                </p> */}

                {allowedModules && typeof allowedModules === "string" && (
                  <p className="text-secondary small">
                    <strong>Note:</strong> {allowedModules}
                  </p>
                )}

                <Button
                  color="primary"
                  className="mt-4"
                  onClick={() => window.history.back()}
                >
                  Go Back
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default NotAuthorized
